import { dao } from '@platform/dao';
import type { IWorkspaceMember } from '@platform/core/types';
import { baseApi, run } from './baseApi';

/** Керування учасниками простору (можливість members): зміна ролі й вилучення; обидві дії оновлюють перелік учасників і лічильники. */
export const membersApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    changeMemberRole: b.mutation<IWorkspaceMember, { ws: string; userId: string; role: string }>({
      queryFn: ({ ws, userId, role }) => run(() => dao.workspaces.changeMemberRole(ws, userId, role)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Workspaces', id: `members:${ws}` }],
    }),
    removeMember: b.mutation<void, { ws: string; userId: string }>({
      queryFn: ({ ws, userId }) => run(() => dao.workspaces.removeMember(ws, userId)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Workspaces', id: `members:${ws}` }],
    }),
  }),
});

export const { useChangeMemberRoleMutation, useRemoveMemberMutation } = membersApi;
